export default __webpack_public_path__ + "images/a6105eacdf4deb9c7be9d7091c61170b-airshow.webp";